import { IconNoProductFound } from "@repo/assets/images";
import { Button } from "@repo/ui";
import { getTranslations } from "next-intl/server";
import Link from "next/link";
const CategoryNotFound = async () => {
  const t = await getTranslations("Common");
  return <div className="py-6 text-center" data-sentry-component="CategoryNotFound" data-sentry-source-file="CategoryNotFound.jsx">
      <IconNoProductFound className="fill-icon-bg text-icon-color mx-auto w-[104px] md:w-[160px]" data-sentry-element="IconNoProductFound" data-sentry-source-file="CategoryNotFound.jsx" />
      <p className="font-heading py-4 text-xl font-medium md:text-4xl">
        {t("Nothing_To_See_Here_Right_Now")}
      </p>
      <p className="pb-4">{t("Our_Shelves_Are_Getting_Stocked")}</p>
      <Link href={`/`} data-sentry-element="Link" data-sentry-source-file="CategoryNotFound.jsx">
        <Button variant="primary" size="md" data-sentry-element="Button" data-sentry-source-file="CategoryNotFound.jsx">
          {t("Back_To_Homepage")}
        </Button>
      </Link>
    </div>;
};
export default CategoryNotFound;